import FunctionalWorkerService from '../../../services/FunctionalWorkerService';
import ChapterUtilFunctionalWorker from './ChapterUtil.functional.worker';
import { CHAPTER_WORKER_MSG } from '../constants';

export default class ChapterUtilWorkerService extends FunctionalWorkerService {
  constructor() {
    super(ChapterUtilFunctionalWorker);
  }

  /**
   * @function getChapters
   * @param  {array} shots
   * @param  {number} maxChapterLength
   * @return {Promise} Promise which resolves with calculated chapters
   */
  getChapters = (shots, targetChapterLength, maxChapterLength) => {
    // the post message will eventually call into the ChapterUtilFunctionalWorker.processMessage
    // provide it with the shots and minChapterLength as the payload
    return this.postMessage(CHAPTER_WORKER_MSG, {
      shots,
      targetChapterLength,
      maxChapterLength,
    });
  };
}
